import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { FaPhoneAlt, FaMobileAlt, FaBars, FaTimes } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';
import { useI18n } from '../../i18n/I18n';

const Navbar = () => {
  const [shrink, setShrink] = useState(false);
  const [openDd, setOpenDd] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, setLang, t } = useI18n();

  useEffect(() => {
    const onScroll = () => setShrink(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { setOpenDd(false); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const onPhoneClick = (label: string) => {
    try {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ event: 'phone_click', location: 'navbar', label });
    } catch {}
  };

  return (
    <nav className={`navbar ${shrink ? 'shrink' : ''}`}>
      <div className="navbar-top">
        <div className="navbar-logo">
          <Link to="/" className="brand">
            <span className="brand-primary">MEZ</span>
            <span className="brand-separator">|</span>
            <span className="brand-secondary">ARAÇ KİRALAMA</span>
          </Link>
        </div>

        <button
          className="mobile-burger"
          aria-label="Menüyü Aç/Kapat"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className="navbar-right">
          <ul className="navbar-links">
            <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>{t('nav.home')}</NavLink></li>
            <li><NavLink to="/bireysel-kiralama" className={({ isActive }) => isActive ? 'active' : ''}>{t('nav.individual')}</NavLink></li>
            <li><NavLink to="/kurumsal-kiralama" className={({ isActive }) => isActive ? 'active' : ''}>{t('nav.corporate')}</NavLink></li>
            <li><NavLink to="/arac-filomuz" className={({ isActive }) => isActive ? 'active' : ''}>{t('vehicles.title')}</NavLink></li>
            <li><NavLink to="/hakkimizda" className={({ isActive }) => isActive ? 'active' : ''}>{t('nav.about')}</NavLink></li>
            <li>
              <select className="lang-switch" value={lang} onChange={(e) => setLang(e.target.value as any)} aria-label="Dil">
                <option value="tr">🇹🇷 TR</option>
                <option value="en">🇬🇧 EN</option>
              </select>
            </li>
            <li>
              <div className="contact-stack">
                <a href="tel:05334904428" className="contact-plain slim" onClick={() => onPhoneClick('05334904428')}>
                  <span className="icon-circle"><FaMobileAlt /></span>
                  <span>0533 490 44 28</span>
                </a>
                <a href="tel:02124680860" className="contact-plain slim" onClick={() => onPhoneClick('02124680860')}>
                  <span className="icon-circle"><FaPhoneAlt /></span>
                  <span>0212 468 08 60</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {mobileOpen && (
        <div className="mobile-menu" role="dialog" aria-label="Gezinme">
          <ul className="mobile-links">
            <li><NavLink to="/" onClick={() => setMobileOpen(false)}>{t('nav.home')}</NavLink></li>
            <li><NavLink to="/bireysel-kiralama" onClick={() => setMobileOpen(false)}>{t('nav.individual')}</NavLink></li>
            <li><NavLink to="/kurumsal-kiralama" onClick={() => setMobileOpen(false)}>{t('nav.corporate')}</NavLink></li>
            <li><NavLink to="/arac-filomuz" onClick={() => setMobileOpen(false)}>{t('vehicles.title')}</NavLink></li>
            <li><NavLink to="/hakkimizda" onClick={() => setMobileOpen(false)}>{t('nav.about')}</NavLink></li>
            <li>
              <select className="lang-switch" value={lang} onChange={(e) => { setLang(e.target.value as any); setMobileOpen(false); }} aria-label="Dil">
                <option value="tr">🇹🇷 TR</option>
                <option value="en">🇬🇧 EN</option>
              </select>
            </li>
            <li className="mobile-contacts">
              <a href="tel:05334904428" className="contact-plain" onClick={() => setMobileOpen(false)}><span className="icon-circle"><FaMobileAlt /></span>0533 490 44 28</a>
              <a href="tel:02124680860" className="contact-plain" onClick={() => setMobileOpen(false)}><span className="icon-circle"><FaPhoneAlt /></span>0212 468 08 60</a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 